import {Component} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, ResolvePlanService} from '../_services';
import {FormBuilder} from '@angular/forms';
import {ResolvePlanNewComponent} from "./resolve-plan-new.component";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './resolve-plan-edit.component.html'
})
export class ResolvePlanEditComponent extends ResolvePlanNewComponent {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: ResolvePlanService,
    protected formBuilder: FormBuilder,
    protected alertService: AlertService
  ) {
    super(router, location, route, planService, formBuilder, alertService);
    this.isNew = false;
  }
}
